import React, { useEffect, useState } from 'react';
import { sprekersApi } from '../api';
import type { SpeakerNote } from '../types';

interface Props {
  engagementId: string;
  /** Alleen de bevoegde (mede)spreker of admin -- zie LiveControlPage. Zolang
   * dit false is, wordt het notes-request bewust helemaal niet uitgevoerd
   * (niet alleen het resultaat verborgen): een presentatieteam-lid dat de
   * bediening als terugval gebruikt, hoeft nooit een privénotitie-call te
   * doen. Dit component wordt nergens op het beamerscherm gebruikt. */
  eligible: boolean;
}

/** Privé-sprekersnotities (sectie 12): uitsluitend zichtbaar voor de
 * bevoegde spreker, geladen via een eigen geauthenticeerde REST-call en
 * nooit via het SSE-kanaal -- zie docs/sprekers-Module.md sectie 32 en
 * backend/sprekers/realtime.py (publish() bevat nooit notitie-inhoud). */
export default function SpeakerNotesPanel({ engagementId, eligible }: Props) {
  const [notes, setNotes] = useState<SpeakerNote[]>([]);

  useEffect(() => {
    if (!eligible) {
      setNotes([]);
      return;
    }
    let active = true;
    sprekersApi.listNotes(engagementId).then((data) => {
      if (active) setNotes(data);
    }).catch(() => {
      if (active) setNotes([]);
    });
    return () => {
      active = false;
    };
  }, [engagementId, eligible]);

  if (!eligible || notes.length === 0) return null;

  return (
    <details className="rounded-lg border border-slate-800 bg-slate-900 p-3 text-sm">
      <summary className="cursor-pointer text-slate-300">Privénotities ({notes.length})</summary>
      <div className="mt-2 space-y-2">
        {notes.map((note) => (
          <p key={note.id} className="whitespace-pre-wrap text-slate-300">{note.note}</p>
        ))}
      </div>
    </details>
  );
}
